import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  
  .close > svg {
    width: var(--modal-close-size);
    height: var(--modal-close-size);
    fill: white;
  }
`;
export const Icon = styled.svg `
  fill: var(--primary-medium, $primary-medium);
  margin-right: 0.7rem;
`;
export const TitleWrapper = styled.div `
  margin-bottom: 0;
  margin-left: 1.6rem;
`;
export const Title = styled.span `
  font: var(--heading-three-font);
  color: var(--primary-darker, $primary-darker);
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    font: var(--heading-two-font);
  }
`;
export default {
    Wrapper,
};
